import { 
  useTranslate,
  // useNavigation,
  // useShow,
  IResourceComponentsProps
} from "@pankod/refine-core";

import {
  List,
  Table,
  // useTable,
  useEditableTable,
  Form,
  Checkbox,
  BooleanField,
  Space,
  EditButton,
  // ShowButton,
  getDefaultSortOrder,
  FilterDropdown,
  Radio,
  // Select,
  // useSelect,
} from "@pankod/refine-antd";

import { IOrganization } from "interfaces";
// import { title } from "process";
// import { IOrganization, ICategory } from "interfaces";

export const OrganizationList: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const {
    tableProps,
    sorter,
    // formProps,
    isEditing,
    // saveButtonProps,
    // cancelButtonProps,
    // setId: setEditId,
  } = useEditableTable<IOrganization>({
    initialSorter: [{
      field: "title",
      order: "asc",
    }],
  });
  // const { tableProps, sorter } = useTable<IOrganization>({
  //   initialSorter: [{
  //     field: "id",
  //     order: "asc",
  //   }],
  //   metaData: {
  //     select: "*",
  //     // select: "*, categories(title)",
  //   },
  // });

  // const { selectProps } = useSelect<ICategory>({
  //     resource: "categories",
  // });

  return (
    <List>
      <Table {...tableProps} rowKey="id">
        <Table.Column
          key="id"
          dataIndex="id"
          title="ID"
          sorter
          defaultSortOrder={getDefaultSortOrder("id", sorter)}
        />
        <Table.Column
          key="title"
          dataIndex="title"
          title={t("organizations.fields.title")}
          sorter
        />
        {/* <Table.Column
          key="codeId"
          dataIndex="codeId"
          title={t("organizations.fields.codeId")}
          sorter
        /> */}
        {/* <Table.Column
          key="code"
          dataIndex="code"
          title={t("organizations.fields.code")}
          sorter
        /> */}
        <Table.Column
          key="is_active"
          dataIndex="is_active"
          title={t("organizations.fields.isActive")}
          filterDropdown={(props) => (
            <FilterDropdown {...props}>
                <Radio.Group>
                  <Radio value="true">{t("status.enable")}</Radio>
                  <Radio value="false">{t("status.disable")}</Radio>
                </Radio.Group>
            </FilterDropdown>
          )}
          /*  render={(value) => <BooleanField value={value} />} */
          render={(value, data: IOrganization) => {
            if (isEditing(data.id)) {
              return (
                <Form.Item
                  name="is_active"
                  style={{ margin: 0 }}
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              );
            }
            return <BooleanField value={value} />;
          }}
        />
                {/* <Table.Column
                    key="categoryId"
                    dataIndex={["categories", "title"]}
                    title="Category"
                    defaultSortOrder={getDefaultSortOrder(
                        "categories.title",
                        sorter,
                    )}
                    filterDropdown={(props) => (
                        <FilterDropdown {...props}>
                            <Select
                                style={{ minWidth: 200 }}
                                mode="multiple"
                                placeholder="Select Category"
                                {...selectProps}
                            />
                        </FilterDropdown>
                    )}
                />
                <Table.Column<IPost>
                    title="Actions"
                    dataIndex="actions"
                    render={(_, record) => (
                        <Space>
                            <EditButton
                                hideText
                                size="small"
                                recordItemId={record.id}
                            />
                            <ShowButton
                                hideText
                                size="small"
                                recordItemId={record.id}
                            />
                        </Space>
                    )}
                />
             */}
        <Table.Column
          key="debug"
          dataIndex="debug"
          title={t("organizations.fields.debug")}
          filterDropdown={(props) => (
            <FilterDropdown {...props}>
                <Radio.Group>
                  <Radio value="true">{t("status.yes")}</Radio>
                  <Radio value="false">{t("status.no")}</Radio>
                </Radio.Group>
            </FilterDropdown>
          )}
          render={(value, data: IOrganization) => {
            if (isEditing(data.id)) {
              return (
                <Form.Item
                  name="debug"
                  style={{ margin: 0 }}
                  valuePropName="checked"
                >
                  <Checkbox />
                </Form.Item>
              );
            }
            return <BooleanField value={value} />;
          }}
        />
        <Table.Column<IOrganization>
          title={t("table.actions")}
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton
                hideText
                size="small"
                recordItemId={record.id}
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};